import { generateParkingText } from '@alluradirect/react';
import { Typography } from '@mui/material';
import Grid from 'components/core/Grid';
import LoadingSkeleton from 'components/core/LoadingSkeleton/LoadingSkeleton';
import { CheckoutSectionTitle } from 'components/views/pages/Checkout/components/CheckoutSectionTitle';
import { BookingCheckoutResponse } from 'components/views/pages/Checkout/hooks/useCheckout';

interface Props {
  checkoutData: BookingCheckoutResponse | undefined;
}

export const CheckoutParkingDetails = ({ checkoutData }: Props) => {
  const isLoading = !checkoutData;

  const numberOfSpotsProvided = checkoutData?.BOOKING?.PROPERTY.PARKING.NUM_SPOTS_PROVIDED ?? 0;
  const hasAdditionalFreeSpots = checkoutData?.BOOKING?.PROPERTY.PARKING.HAS_ADDITIONAL_FREE_SPOTS ?? false;
  const hasAdditionalPaidSpots = checkoutData?.BOOKING?.PROPERTY.PARKING.HAS_ADDITIONAL_PAID_SPOTS ?? false;

  const parkingText = generateParkingText({
    numberOfSpotsProvided,
    hasAdditionalFreeSpots,
    hasAdditionalPaidSpots,
  });

  return (
    <Grid item xs={12}>
      <LoadingSkeleton isLoading={isLoading}>
        <CheckoutSectionTitle>Parking</CheckoutSectionTitle>
      </LoadingSkeleton>
      <LoadingSkeleton isLoading={isLoading} scaleOneToOne>
        <Typography variant="body1">{parkingText}</Typography>
      </LoadingSkeleton>
    </Grid>
  );
};
